export default __webpack_public_path__ + "static/media/insta-large.40321cf1.svg";